import { Link, useLocation } from 'react-router-dom';

const NavigationLinks = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/patients', label: '👥 Patient Intake' },
    { path: '/insights', label: '📊 XAI Insights Core' },
    { path: '/capture', label: '🎙️ Modality Capture' },
    { path: '/analytics', label: '📈 System Analytics' }
  ];

  return (
    <nav className="flex gap-4 border-b border-slate-200 pb-4 mb-6">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
            location.pathname === item.path
              ? 'bg-indigo-50 text-indigo-600 border border-indigo-200'
              : 'text-slate-600 hover:bg-slate-50'
          }`}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

export default NavigationLinks;
